export default {"src":"/_next/static/media/american-express.9b0e05f2.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};